import React from 'react';

import cn from 'classnames';
import PropTypes from 'prop-types';
import { MdArrowDownward, MdSwapVert } from 'react-icons/md';

import { sortOrderPropTypes } from '../../constants';
import styles from './SortIcon.less';

const SortIcon = ({ order, className }) => (
  <div className={cn(styles.container, className)}>
    <MdSwapVert className={cn(styles.sortIcon, styles.nosort, order)} />
    <MdArrowDownward className={cn(styles.sortIcon, styles.down, order)} />
  </div>
);

SortIcon.propTypes = {
  order: sortOrderPropTypes,
  className: PropTypes.string,
};

export default SortIcon;
